import {LOGIN, LOGOUT} from './../user/actions';
import {MODIFY_SKIRESORT, DELETE_SKIRESORT} from './../skiresorts/actions';
import {CHANGE_DATE, CHANGE_SKIRESORT} from './../global/actions';

import {Status} from '../_commons/const';

const initialState = {
  status: Status.OK,
  infos: null,
  selectedSkiresort: null,
  selectedSkiresortIsUpdating: false,
  selectedDate: Date.now()
};


export default function (state = initialState, action) {
  let update = (before, options) => Object.assign({}, before, options);
  switch (action.type) {
    case LOGIN.do:
      return update(initialState, {status: Status.LOADING});
    case LOGIN.success:
      return update(initialState, {
	  infos: action.infos,
	  selectedSkiresort: action.infos.ski_resorts.length === 1 ? action.infos.ski_resorts[0] : null
      });
    case LOGIN.failure:
      return update(initialState, {status: Status.FAILURE});
    case CHANGE_SKIRESORT:
      return update(state, {selectedSkiresort: action.skiresort, selectedDate: Date.now()});
    case LOGOUT:
      return initialState;
    case MODIFY_SKIRESORT.do:
      return update(state, {selectedSkiresortIsUpdating: true});
    case MODIFY_SKIRESORT.success:
      if (action.payload.id === state.selectedSkiresort.id) {
        return update(state, {
          selectedSkiresort: action.payload,
          selectedSkiresortIsUpdating: false
        });
      } else {
        return state;
      }
    case DELETE_SKIRESORT.success:
      let userCopy = Object.assign({}, state.infos);
      userCopy.ski_resorts = userCopy.ski_resorts.filter(({id}) => id !== action.id);
      return update(state, {infos: userCopy});
    case MODIFY_SKIRESORT.failure:
      if (action.payload.id === state.selectedSkiresort.id) {
        return update(state, {selectedSkiresortIsUpdating: false});
      } else {
        return state;
      }
    case CHANGE_DATE:
      return update(state, {
        selectedDate: action.date
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/user/reducer.js